/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientEntity } from './ClientEntity';
import {
    ClientEntityFromJSON,
    ClientEntityFromJSONTyped,
    ClientEntityToJSON,
} from './ClientEntity';

/**
 * 
 * @export
 * @interface ClientEntityResponse
 */
export interface ClientEntityResponse {
    /**
     * 
     * @type {ClientEntity}
     * @memberof ClientEntityResponse
     */
    client?: ClientEntity;
}

/**
 * Check if a given object implements the ClientEntityResponse interface.
 */
export function instanceOfClientEntityResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClientEntityResponseFromJSON(json: any): ClientEntityResponse {
    return ClientEntityResponseFromJSONTyped(json, false);
}

export function ClientEntityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientEntityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client': !exists(json, 'client') ? undefined : ClientEntityFromJSON(json['client']),
    };
}

export function ClientEntityResponseToJSON(value?: ClientEntityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client': ClientEntityToJSON(value.client),
    };
}

